import { createSvgIcon } from '@mui/material';

const IconLinkedin = createSvgIcon(
  <path d="M4 8.44444H7.55556V20H4V8.44444ZM5.77778 4C4.71111 4 4 4.88889 4 5.86667C4 6.75556 4.71111 7.55556 5.77778 7.55556C6.93333 7.55556 7.55556 6.75556 7.55556 5.77778C7.55556 4.8 6.84444 4 5.77778 4ZM16.0889 8.62222C14.2222 8.62222 13.1556 9.68889 12.7111 10.4H12.6222L12.4444 8.88889H9.24444C9.24444 9.86667 9.33333 11.0222 9.33333 12.3556V20H12.8889V13.6889C12.8889 13.3333 12.8889 13.0667 12.9778 12.8C13.2444 12.1778 13.6889 11.3778 14.6667 11.3778C15.9111 11.3778 16.4444 12.4444 16.4444 13.8667V20H20V13.4222C20 10.1333 18.3111 8.62222 16.0889 8.62222Z" />,
  'linkedin',
);

export default IconLinkedin;
